const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const objectsEqual = (o1, o2) => Object.keys(o1).length === Object.keys(o2).length
  && Object.keys(o1).every((key) => o1[key] === o2[key]);

const compareArrayOfObjects = (a1, a2) => {
  if (a1.length !== a2.length) {
    return false;
  }

  for (let i = 0; i < a1.length; i += 1) {
    if (!objectsEqual(a1[i], a2[i])) {
      return false;
    }
  }

  return true;
};

export { reorder, compareArrayOfObjects };
